import script from "./LogotypeCapital.vue?vue&type=script&setup=true&lang=js"
export * from "./LogotypeCapital.vue?vue&type=script&setup=true&lang=js"

import "./LogotypeCapital.vue?vue&type=style&index=0&id=fcc20be2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fcc20be2"]])

export default __exports__